import { defineMessages } from "react-intl";

export default defineMessages({
  chooseBetweenTheTwoFormulas: {
    id: "chooseFormulaPage.chooseBetweenTheTwoFormulas",
    defaultMessage:
      "Choose between the two formulas to continue with {serviceProviderName}.",
  },
  goBack: {
    id: "chooseFormulaPage.goBack",
    defaultMessage: "Go back to the offers",
  },
  getMoreFromRingTwice: {
    id: "chooseFormulaPage.getMoreFromRingTwice",
    defaultMessage: "Get more from Ring Twice",
  },
});
